import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector   : 'app-root',
    templateUrl: './app.component.html',
    styleUrls  : ['./app.component.scss']
})
export class AppComponent
{
    /**
     * Constructor
     */
    constructor(
        private _router: Router,
    )
    {
    }
    ngOnInit(): void {
        // (!!localStorage.getItem('accessToken'))?this._router.navigateByUrl('/home'):this._router.navigateByUrl('/sign-in');
        //Igual si no esta autenticado, siempre redirecciona al sign-in, pero lo dejo asi para que no muestre
        //'?redirectURL=%2Fhome' en la url cuando no esté autenticado
    }
}
